import { getClasses } from "../getClasses/getClasses";
import { replaceAll } from "../replaceAll";

type StringPlaceholderType = {
  placeholder: string;
  value: string | number;
  tag?: string;
  additionalProps?: string;
};

export const replaceStringPlaceholder = (
  text: string,
  placeholders: StringPlaceholderType[],
  withStyles = true
): string => {
  if (!text) {
    return "";
  }

  return placeholders.reduce((prev: string, current: StringPlaceholderType) => {
    const props = getClasses([`class="placeholder placeholder-${current.placeholder}"`, current.additionalProps]);
    const { tag = "span", placeholder, value } = current;
    const text = value.toString();

    return replaceAll(prev, `{#${placeholder}#}`, withStyles ? `<${tag} ${props}>${value}</${tag}>` : text);
  }, text);
};
